.member-shell {
  --mnavy: #062e56;
  --mblue: #1475e5;
  --mgreen: #07945b;
  --mtext: #132035;
  --mmuted: #6b788b;
  min-height: 100vh;
  background: #f4f7fb;
  color: var(--mtext);
  display: flex;
}
.member-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  width: 252px;
  background: linear-gradient(180deg, #052f56, #031e38);
  color: #fff;
  padding: 22px 16px;
  display: flex;
  flex-direction: column;
  z-index: 50;
}
.member-brand {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 4px 8px 22px;
}
.member-brand > span {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #fff;
  color: #07335b;
  display: grid;
  place-items: center;
  letter-spacing: -3px;
  font-size: 12px;
}
.member-brand b {
  font-size: 17px;
  letter-spacing: 0.2px;
}
.member-brand i,
.member-mobile-brand i {
  font-style: normal;
  color: #63adff;
}
.member-brand small {
  display: block;
  font-size: 8px;
  letter-spacing: 1.4px;
  color: #acc5dd;
  margin-top: 2px;
}
.member-side-person {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 14px 10px;
  background: #ffffff0d;
  border: 1px solid #ffffff12;
  border-radius: 12px;
  margin-bottom: 16px;
}
.member-side-person img {
  width: 42px;
  height: 42px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid #fff;
}
.member-side-person b,
.member-side-person small {
  display: block;
}
.member-side-person b {
  font-size: 11px;
}
.member-side-person small {
  font-size: 9px;
  color: #9bc1e4;
  margin-top: 3px;
}
.member-sidebar nav {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.member-sidebar nav button {
  border: 0;
  background: transparent;
  color: #c8d7e7;
  padding: 11px 13px;
  border-radius: 9px;
  text-align: left;
  display: flex;
  gap: 13px;
  align-items: center;
  cursor: pointer;
  font-weight: 600;
}
.member-sidebar nav button span {
  font-size: 17px;
  width: 20px;
  text-align: center;
}
.member-sidebar nav button:hover,
.member-sidebar nav button.active {
  background: linear-gradient(90deg, #0a5db9, #1276df);
  color: #fff;
  box-shadow: 0 8px 20px #001b3988;
}
.member-side-status {
  display: flex;
  gap: 10px;
  align-items: center;
  background: #0d724d3d;
  border: 1px solid #42d5963d;
  padding: 12px;
  border-radius: 11px;
  margin-top: auto;
}
.member-side-status > span {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  background: #19a86a;
  display: grid;
  place-items: center;
}
.member-side-status b,
.member-side-status small {
  display: block;
}
.member-side-status b {
  font-size: 10px;
}
.member-side-status small {
  font-size: 8px;
  color: #a9d8c2;
  margin-top: 2px;
}
.member-exit {
  border: 0;
  background: transparent;
  color: #a8bfd4;
  font-size: 10px;
  padding: 14px;
  cursor: pointer;
}
.member-workspace {
  margin-left: 252px;
  flex: 1;
  min-width: 0;
}
.member-workspace > header {
  height: 70px;
  background: #fff;
  border-bottom: 1px solid #e0e7ef;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  position: sticky;
  top: 0;
  z-index: 25;
}
.member-workspace > header > img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;
}
.member-hamb,
.member-mobile-brand {
  display: none;
}
.member-alert {
  width: 38px;
  height: 38px;
  border: 0;
  background: #edf4fc;
  border-radius: 50%;
  color: #315777;
  position: relative;
  font-size: 18px;
}
.member-alert span {
  position: absolute;
  right: -2px;
  top: -4px;
  background: #e83a46;
  color: #fff;
  font-size: 8px;
  border-radius: 10px;
  padding: 2px 5px;
}
.member-page {
  padding: 30px 34px 70px;
  max-width: 1500px;
  margin: auto;
}
.member-welcome {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 22px;
}
.member-welcome span,
.member-page-head > span {
  color: #1372d7;
  font-weight: 800;
  font-size: 10px;
  letter-spacing: 1.5px;
}
.member-welcome h1,
.member-page-head h1 {
  font-size: 29px;
  margin: 5px 0 6px;
  letter-spacing: -0.8px;
}
.member-welcome p,
.member-page-head p {
  margin: 0;
  color: var(--mmuted);
}
.member-welcome > button {
  border: 0;
  background: #0969d5;
  color: #fff;
  border-radius: 10px;
  padding: 12px 18px;
  font-weight: 750;
  box-shadow: 0 8px 18px #0d6bd538;
  cursor: pointer;
}
.member-hero {
  height: 370px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 12px 35px #09284a28;
}
.member-hero > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s;
}
.member-hero:hover > img {
  transform: scale(1.02);
}
.member-hero-shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    #041d37ed 0%,
    #061e3a9c 46%,
    transparent 80%
  );
}
.member-hero-copy {
  position: absolute;
  left: 42px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 500px;
}
.member-hero-copy > small {
  font-size: 9px;
  letter-spacing: 2px;
  color: #8fc5ff;
}
.member-hero-copy h2 {
  font-size: 34px;
  margin: 9px 0;
}
.member-hero-copy p {
  font-size: 14px;
  line-height: 1.5;
  color: #d3e0eb;
}
.member-hero-copy > b {
  display: block;
  color: #75efb6;
  font-size: 19px;
  margin: 17px 0;
}
.member-hero-copy button {
  border: 1px solid #ffffff55;
  background: #ffffff18;
  color: #fff;
  border-radius: 9px;
  padding: 10px 14px;
  font-weight: 700;
}
.member-dots {
  position: absolute;
  left: 42px;
  bottom: 22px;
  display: flex;
  gap: 7px;
}
.member-dots button {
  width: 8px;
  height: 8px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: #ffffff77;
}
.member-dots button.active {
  width: 28px;
  background: #fff;
}
.member-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 13px;
  margin: 16px 0 30px;
}
.member-summary-grid article {
  display: flex;
  align-items: center;
  gap: 13px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 13px;
  padding: 16px;
  box-shadow: 0 3px 10px #16304d0b;
}
.member-summary-grid article > span {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  color: #fff;
  font-size: 19px;
}
.member-summary-grid .green {
  background: #0da267;
}
.member-summary-grid .blue {
  background: #1877e5;
}
.member-summary-grid .orange {
  background: #f09d25;
}
.member-summary-grid small,
.member-summary-grid b,
.member-summary-grid em {
  display: block;
}
.member-summary-grid small {
  font-size: 9px;
  color: var(--mmuted);
}
.member-summary-grid b {
  font-size: 17px;
  margin: 2px 0;
}
.member-summary-grid em {
  font-size: 8px;
  color: #8490a0;
  font-style: normal;
}
.member-section-title {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin: 27px 0 14px;
}
.member-section-title h2 {
  font-size: 20px;
  margin: 0 0 3px;
}
.member-section-title p {
  margin: 0;
  color: var(--mmuted);
  font-size: 11px;
}
.member-section-title button {
  border: 0;
  background: transparent;
  color: #126bd1;
  font-weight: 700;
  font-size: 11px;
}
.member-brand-strip {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}
.member-brand-strip > button {
  background: #fff;
  border: 1px solid #e2e8ef;
  border-radius: 14px;
  padding: 17px 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}
.member-brand-strip b {
  font-size: 11px;
  margin-top: 9px;
}
.member-brand-strip small {
  font-size: 9px;
  color: var(--mmuted);
  margin-top: 3px;
}
.brand-bubble {
  width: 58px;
  height: 58px;
  border-radius: 17px;
  background: linear-gradient(135deg, #ff9d16, #ffba36);
  color: #fff;
  display: grid;
  place-items: center;
  font-weight: 850;
  box-shadow: 0 6px 14px #2438511c;
  overflow: hidden;
}
.brand-bubble img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.brand-bubble.b1 {
  background: linear-gradient(135deg, #1c79dc, #4eb6ed);
}
.brand-bubble.b2 {
  background: linear-gradient(135deg, #13a478, #4ac59d);
}
.brand-bubble.b3 {
  background: linear-gradient(135deg, #c64031, #f58143);
}
.brand-bubble.b4 {
  background: linear-gradient(135deg, #6451bd, #9e6edb);
}
.member-offer-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 13px;
}
.member-offer {
  background: #fff;
  border: 1px solid #e2e8ef;
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 3px 13px #17324f0c;
}
.member-offer > div {
  height: 145px;
  position: relative;
}
.member-offer img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.member-offer > div > b {
  position: absolute;
  right: 10px;
  top: 10px;
  background: #07945b;
  color: white;
  border-radius: 15px;
  padding: 7px 10px;
  font-size: 11px;
}
.member-offer > small,
.member-offer h3,
.member-offer p,
.member-offer > button {
  margin-left: 14px;
  margin-right: 14px;
}
.member-offer > small {
  display: block;
  color: #1671d7;
  font-size: 8px;
  font-weight: 800;
  margin-top: 13px;
  text-transform: uppercase;
}
.member-offer h3 {
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.member-offer p {
  font-size: 10px;
  color: var(--mmuted);
  min-height: 31px;
}
.member-offer > button {
  border: 0;
  background: transparent;
  color: #126bd1;
  font-size: 10px;
  font-weight: 750;
  padding: 0 0 15px;
}
.member-notice,
.member-help {
  display: flex;
  gap: 13px;
  align-items: center;
  background: #fff7df;
  border: 1px solid #f7dda0;
  border-radius: 13px;
  padding: 15px;
  margin-top: 25px;
}
.member-notice > div,
.member-help > div {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #f4ad27;
  color: #fff;
  font-weight: 900;
}
.member-notice p,
.member-help p {
  flex: 1;
  margin: 0;
}
.member-notice b,
.member-notice span,
.member-help b,
.member-help span {
  display: block;
}
.member-notice b,
.member-help b {
  font-size: 11px;
}
.member-notice span,
.member-help span {
  font-size: 9px;
  color: #756b58;
  margin-top: 3px;
}
.member-notice button,
.member-help button {
  border: 0;
  background: #fff;
  border-radius: 8px;
  padding: 9px 12px;
  color: #8a6106;
  font-size: 10px;
  font-weight: 700;
}
.member-page-head {
  margin-bottom: 22px;
}
.member-search {
  height: 50px;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #dce4ed;
  border-radius: 12px;
  padding: 0 16px;
  gap: 10px;
}
.member-search span {
  font-size: 22px;
  color: #66788c;
}
.member-search input {
  border: 0;
  outline: 0;
  flex: 1;
  font-size: 13px;
}
.member-chips {
  display: flex;
  gap: 8px;
  overflow: auto;
  padding: 14px 0 19px;
}
.member-chips button {
  border: 1px solid #dbe4ee;
  background: #fff;
  border-radius: 20px;
  padding: 8px 14px;
  color: #617086;
  font-size: 10px;
  white-space: nowrap;
}
.member-chips button.active {
  background: #0e6bd6;
  border-color: #0e6bd6;
  color: #fff;
}
.member-partner-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.member-partner-grid article {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 17px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 5px 18px #15304c0d;
}
.member-partner-image {
  height: 210px;
  position: relative;
}
.member-partner-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.member-partner-image > span {
  position: absolute;
  right: 12px;
  top: 12px;
  background: #0b9660;
  color: #fff;
  border-radius: 17px;
  padding: 7px 11px;
  font-weight: 800;
}
.member-partner-card-head {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 0 17px;
  margin-top: -31px;
  position: relative;
}
.member-partner-card-head .brand-bubble {
  border: 5px solid #fff;
  width: 65px;
  height: 65px;
}
.member-partner-card-head h2 {
  font-size: 16px;
  margin: 27px 0 2px;
}
.member-partner-card-head p {
  font-size: 9px;
  color: var(--mmuted);
  margin: 0;
}
.member-partner-grid article > p {
  font-size: 10px;
  color: var(--mmuted);
  line-height: 1.5;
  min-height: 46px;
  padding: 0 17px;
}
.member-partner-grid article > button {
  border: 0;
  border-top: 1px solid #edf1f5;
  background: #fff;
  color: #126bd1;
  font-size: 10px;
  font-weight: 750;
  width: 100%;
  text-align: left;
  padding: 14px 17px;
}
.card-page {
  max-width: 850px;
}
.digital-card {
  background:
    radial-gradient(circle at 90% 10%, #3088dc 0, #3088dc00 30%),
    linear-gradient(135deg, #07345e, #075da6);
  color: #fff;
  border-radius: 24px;
  padding: 27px;
  box-shadow: 0 20px 50px #062c5460;
  position: relative;
  overflow: hidden;
}
.digital-card:after {
  content: "";
  position: absolute;
  width: 260px;
  height: 260px;
  border: 45px solid #ffffff0a;
  border-radius: 50%;
  right: -100px;
  bottom: -140px;
}
.digital-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.member-brand.inverse {
  padding: 0;
}
.member-brand.inverse > span {
  background: #fff;
}
.card-active {
  background: #0b9b61;
  border-radius: 15px;
  padding: 7px 11px;
  font-size: 9px;
  font-weight: 800;
}
.digital-person {
  display: flex;
  align-items: center;
  gap: 17px;
  margin: 32px 0;
}
.digital-person img {
  width: 88px;
  height: 88px;
  border-radius: 18px;
  object-fit: cover;
  border: 3px solid #ffffffcc;
}
.digital-person small {
  font-size: 8px;
  color: #abd2f5;
  letter-spacing: 1.5px;
}
.digital-person h2 {
  font-size: 23px;
  margin: 4px 0;
}
.digital-person p {
  margin: 0 0 9px;
  color: #bed4e9;
}
.digital-person b {
  font-size: 12px;
}
.digital-bottom {
  display: flex;
  gap: 60px;
  border-top: 1px solid #ffffff25;
  padding-top: 17px;
}
.digital-bottom small,
.digital-bottom b {
  display: block;
}
.digital-bottom small {
  font-size: 7px;
  letter-spacing: 1.4px;
  color: #9fc8ec;
}
.digital-bottom b {
  font-size: 11px;
  margin-top: 3px;
}
.qr-display {
  background: #fff;
  border: 1px solid #e0e7ef;
  border-radius: 18px;
  text-align: center;
  padding: 25px;
  margin-top: 17px;
}
.qr-display > div {
  width: min(310px, 80vw);
  height: min(310px, 80vw);
  margin: auto;
  display: grid;
  place-items: center;
}
.qr-display img {
  width: 100%;
  height: 100%;
}
.qr-display h2 {
  font-size: 17px;
  margin: 13px 0 5px;
}
.qr-display p {
  color: var(--mmuted);
  font-size: 10px;
  max-width: 450px;
  margin: 0 auto 12px;
}
.qr-display > span {
  display: inline-block;
  background: #eaf3ff;
  color: #1260b8;
  border-radius: 15px;
  padding: 6px 10px;
  font-size: 9px;
}
.card-security,
.member-privacy {
  background: #e8f3ff;
  color: #174f85;
  border-radius: 11px;
  padding: 13px 16px;
  margin-top: 15px;
}
.card-security b,
.card-security p,
.member-privacy b,
.member-privacy p {
  margin: 0;
}
.card-security p,
.member-privacy p {
  font-size: 10px;
  margin-top: 4px;
}
.payment-reminder {
  background: linear-gradient(135deg, #073967, #0871cc);
  color: #fff;
  padding: 27px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 12px 30px #07335d2f;
}
.payment-reminder small {
  font-size: 8px;
  letter-spacing: 1.6px;
  color: #9ecbf2;
}
.payment-reminder h2 {
  font-size: 30px;
  margin: 5px 0;
}
.payment-reminder p {
  margin: 0;
  color: #c7dbed;
}
.payment-reminder span {
  display: inline-block;
  margin-top: 13px;
  background: #0a9660;
  border-radius: 13px;
  padding: 5px 9px;
  font-size: 9px;
}
.payment-reminder button {
  border: 0;
  background: #fff;
  color: #095da9;
  border-radius: 10px;
  padding: 12px 18px;
  font-weight: 800;
}
.member-payment-list {
  background: #fff;
  border: 1px solid #e0e7ef;
  border-radius: 14px;
  padding: 0 18px;
}
.member-payment-list article {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  gap: 13px;
  padding: 15px 0;
  border-bottom: 1px solid #edf1f5;
}
.member-payment-list article:last-child {
  border: 0;
}
.member-payment-list article > span {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #def6e9;
  color: #08804b;
}
.member-payment-list b,
.member-payment-list small {
  display: block;
}
.member-payment-list b {
  font-size: 11px;
}
.member-payment-list small {
  font-size: 9px;
  color: var(--mmuted);
  margin-top: 3px;
}
.member-payment-list strong {
  font-size: 12px;
}
.member-payment-list em {
  background: #def6e9;
  color: #08804b;
  border-radius: 12px;
  padding: 5px 8px;
  font-size: 8px;
  font-style: normal;
}
.member-help {
  background: #edf5ff;
  border-color: #cfe2fa;
}
.member-help > div {
  background: #2778d4;
}
.member-help button {
  color: #1261b7;
}
.member-profile {
  background: #fff;
  border: 1px solid #e0e7ef;
  border-radius: 16px;
  padding: 24px;
}
.profile-person {
  display: flex;
  align-items: center;
  gap: 17px;
  border-bottom: 1px solid #edf1f5;
  padding-bottom: 21px;
}
.profile-person img {
  width: 90px;
  height: 90px;
  border-radius: 20px;
  object-fit: cover;
}
.profile-person h2 {
  margin: 0 0 5px;
}
.profile-person p {
  color: var(--mmuted);
  margin: 0 0 8px;
}
.profile-person span {
  font-size: 9px;
  color: #07814e;
  background: #e1f6eb;
  border-radius: 12px;
  padding: 5px 8px;
}
.member-profile-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  background: #edf1f5;
  margin: 20px 0;
}
.member-profile-grid > div {
  background: #fff;
  padding: 15px;
}
.member-profile-grid small,
.member-profile-grid b {
  display: block;
}
.member-profile-grid small {
  font-size: 9px;
  color: var(--mmuted);
}
.member-profile-grid b {
  font-size: 11px;
  margin-top: 4px;
}
.member-profile > button {
  border: 1px solid #b9d2ee;
  background: #fff;
  color: #1266c3;
  border-radius: 9px;
  padding: 10px 14px;
  font-weight: 700;
}
.member-back {
  border: 0;
  background: transparent;
  color: #126bd1;
  font-weight: 700;
  margin-bottom: 14px;
}
.member-public-profile {
  background: #fff;
  border: 1px solid #e0e7ef;
  border-radius: 19px;
  overflow: hidden;
}
.member-public-cover {
  height: 390px;
}
.member-public-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.member-public-identity {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 0 32px;
  margin-top: -38px;
  position: relative;
}
.member-public-identity .brand-bubble {
  width: 88px;
  height: 88px;
  border: 7px solid #fff;
  border-radius: 24px;
  font-size: 20px;
}
.member-public-identity > div {
  flex: 1;
  padding-top: 43px;
}
.member-public-identity small {
  color: #1371d6;
  font-size: 9px;
  font-weight: 800;
  text-transform: uppercase;
}
.member-public-identity h1 {
  font-size: 25px;
  margin: 3px 0;
}
.member-public-identity h1 i {
  font-style: normal;
  color: #1886e8;
}
.member-public-identity p {
  color: var(--mmuted);
  margin: 0;
}
.member-public-identity > b {
  margin-top: 40px;
  background: #dff7eb;
  color: #07834f;
  border-radius: 20px;
  padding: 9px 13px;
}
.member-public-facts {
  display: flex;
  gap: 25px;
  flex-wrap: wrap;
  padding: 25px 32px;
  border-bottom: 1px solid #edf1f5;
  color: #637184;
  font-size: 10px;
}
.member-public-content {
  padding: 0 32px 30px;
}
.member-profile-offers {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 13px;
}
.member-profile-offers article {
  border: 1px solid #e1e7ee;
  border-radius: 13px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 150px 1fr;
}
.member-profile-offers img {
  width: 150px;
  height: 150px;
  object-fit: cover;
}
.member-profile-offers article > div {
  padding: 16px;
}
.member-profile-offers span {
  display: inline-block;
  background: #0a965d;
  color: #fff;
  border-radius: 13px;
  padding: 5px 8px;
  font-size: 9px;
  font-weight: 800;
}
.member-profile-offers h2 {
  font-size: 15px;
  margin: 8px 0 4px;
}
.member-profile-offers p {
  font-size: 10px;
  color: var(--mmuted);
}
.member-profile-offers small {
  font-size: 8px;
  color: #8792a2;
}
.member-conditions {
  background: #f5f7fa;
  border-radius: 11px;
  padding: 15px;
  margin-top: 18px;
}
.member-conditions p {
  font-size: 10px;
  color: var(--mmuted);
  margin: 5px 0 0;
}
.member-bottom-nav {
  display: none;
}
.member-loading,
.member-empty {
  min-height: 70vh;
  display: grid;
  place-content: center;
  text-align: center;
  color: var(--mmuted);
}
.member-loading > div {
  width: 42px;
  height: 42px;
  border: 4px solid #dce8f5;
  border-top-color: #1473db;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: auto;
}
.member-toast {
  position: fixed;
  right: 24px;
  bottom: 24px;
  background: #063759;
  color: #fff;
  border-radius: 10px;
  padding: 13px 18px;
  z-index: 90;
  box-shadow: 0 10px 28px #001c3977;
}
.member-shade {
  display: none;
}
.member-demo-login {
  width: 100%;
  border: 1px solid #b9d2ee;
  border-radius: 9px;
  background: #edf5ff;
  color: #125fae;
  padding: 11px;
  font-weight: 750;
  margin: -8px 0 15px;
  cursor: pointer;
}
@media (max-width: 1100px) {
  .member-offer-row {
    grid-template-columns: repeat(2, 1fr);
  }
  .member-partner-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .member-brand-strip {
    grid-template-columns: repeat(5, minmax(120px, 1fr));
    overflow: auto;
  }
  .member-brand-strip > button {
    min-width: 120px;
  }
}
@media (max-width: 800px) {
  .member-sidebar {
    transform: translateX(-100%);
    transition: 0.25s;
  }
  .member-sidebar.open {
    transform: translateX(0);
  }
  .member-workspace {
    margin-left: 0;
    padding-bottom: 68px;
  }
  .member-workspace > header {
    padding: 0 15px;
    justify-content: space-between;
  }
  .member-hamb,
  .member-mobile-brand {
    display: block;
  }
  .member-hamb {
    border: 0;
    background: transparent;
    font-size: 23px;
  }
  .member-mobile-brand {
    font-size: 16px;
    font-weight: 850;
  }
  .member-workspace > header > .member-alert {
    margin-left: auto;
  }
  .member-page {
    padding: 20px 15px 35px;
  }
  .member-hero {
    height: 360px;
  }
  .member-hero-copy {
    left: 24px;
    right: 24px;
  }
  .member-dots {
    left: 24px;
  }
  .member-summary-grid {
    grid-template-columns: 1fr;
  }
  .member-partner-grid {
    grid-template-columns: 1fr 1fr;
  }
  .member-bottom-nav {
    display: flex;
    position: fixed;
    inset: auto 0 0 0;
    height: 67px;
    background: #fff;
    border-top: 1px solid #dce4ed;
    z-index: 40;
    justify-content: space-around;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .member-bottom-nav button {
    border: 0;
    background: #fff;
    color: #718094;
    min-width: 75px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
  }
  .member-bottom-nav button span {
    font-size: 18px;
  }
  .member-bottom-nav button small {
    font-size: 8px;
  }
  .member-bottom-nav button.active {
    color: #0c6ed9;
  }
  .member-shade {
    display: block;
    position: fixed;
    inset: 0;
    background: #001b3588;
    z-index: 45;
  }
  .member-public-cover {
    height: 300px;
  }
  .member-profile-offers {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 560px) {
  .member-welcome {
    display: block;
  }
  .member-welcome h1,
  .member-page-head h1 {
    font-size: 24px;
  }
  .member-welcome > button {
    width: 100%;
    margin-top: 16px;
  }
  .member-hero {
    height: 410px;
  }
  .member-hero-shade {
    background: linear-gradient(0deg, #041d38f5 0%, #0523419c 62%, transparent);
  }
  .member-hero-copy {
    top: auto;
    bottom: 45px;
    transform: none;
  }
  .member-hero-copy h2 {
    font-size: 26px;
  }
  .member-hero-copy p {
    font-size: 12px;
  }
  .member-dots {
    bottom: 18px;
  }
  .member-offer-row {
    display: flex;
    overflow: auto;
  }
  .member-offer {
    min-width: 270px;
  }
  .member-partner-grid {
    grid-template-columns: 1fr;
  }
  .member-partner-image {
    height: 230px;
  }
  .payment-reminder {
    display: block;
  }
  .payment-reminder button {
    width: 100%;
    margin-top: 20px;
  }
  .member-payment-list article {
    grid-template-columns: auto 1fr auto;
  }
  .member-payment-list em {
    display: none;
  }
  .profile-person img {
    width: 75px;
    height: 75px;
  }
  .member-profile-grid {
    grid-template-columns: 1fr;
  }
  .member-public-cover {
    height: 260px;
  }
  .member-public-identity {
    display: grid;
    grid-template-columns: auto 1fr;
    padding: 0 17px;
    margin-top: -34px;
  }
  .member-public-identity .brand-bubble {
    width: 74px;
    height: 74px;
  }
  .member-public-identity > div {
    padding-top: 38px;
  }
  .member-public-identity > div p {
    grid-column: 1/-1;
  }
  .member-public-identity > b {
    grid-column: 1/-1;
    margin: 10px 0 0;
    text-align: center;
  }
  .member-public-facts {
    display: grid;
    gap: 9px;
    padding: 20px 17px;
  }
  .member-public-content {
    padding: 0 17px 22px;
  }
  .member-profile-offers article {
    grid-template-columns: 110px 1fr;
  }
  .member-profile-offers img {
    width: 110px;
    height: 140px;
    object-fit: cover;
  }
  .member-profile-offers article > div {
    padding: 12px;
  }
  .digital-card {
    padding: 20px;
  }
  .digital-person img {
    width: 72px;
    height: 72px;
  }
  .digital-person h2 {
    font-size: 18px;
  }
  .digital-bottom {
    gap: 30px;
  }
}
